import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link, withRouter } from "react-router-dom";
import { Alert, Button, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Form, FormGroup, Input, Label } from 'reactstrap';
import ErrorBoundary from './ErrorBoundary';
import NotAuthenticated from './NotAuthenticated';
import * as Accounts from '../store/Accounts';
import * as elements from '../data/Elements';
import * as paths from '../data/Paths';
import * as utility from '../data/Utility';

const createAccountType = {
    email: "email",
    firstName: "firstName",
    lastName: "lastName",
    password: "password",
    phoneNumber: "phoneNumber",
    role: "role",
    userName: "userName",
	enabled: "enabled",
}

class CreateAccountInternal extends React.Component {
    constructor(props) {
        super(props);

        const create = utility.propCheck(props.create, false);
        const editing = utility.propCheck(props.editing, true);
        const linkReturn = utility.propCheck(props.linkReturn, false);
        const site = utility.propCheck(props.site, null);
        const studies = utility.propCheck(props.studies, null);
        const userName = utility.propCheck(props.userName, "");
        this.state = {
            accountFetched: false,
            create: create,
            editing: editing,
            error: false,
            linkReturn: linkReturn,
            message: "",
			msgEmailConfirmation: null,
            passwordConfirm: "",
            resetPassword: Accounts.emptyAccount.resetPassword,
            roleDropdownOpen: false,
            site: site,
            studies: studies,
            userName: userName
        };

        this.getByName = this.getByName.bind(this);
        this.getFormGroups = this.getFormGroups.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handlePasswordConfirm = this.handlePasswordConfirm.bind(this);
        this.handleSendAccountConfirmationEmail = this.handleSendAccountConfirmationEmail.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleValue = this.handleValue.bind(this);
    }

    componentDidMount() {
        Accounts.checkAuthenticated(this.props.accountsState.authenticated, this.props.accountsDispatch);
    }

    componentDidUpdate(prevProps) {
        const accountsState = this.props.accountsState;
        const authenticated = Accounts.authenticatedAllRoles(accountsState);
        if (Accounts.authenticatedPrevProps(prevProps, authenticated, accountsState.fetching, !this.state.accountFetched)) {
            if (!this.state.linkReturn) {
                if (this.state.create) {
                    const account = JSON.parse(JSON.stringify(Accounts.emptyAccount));
                    this.props.accountsDispatch.set(account);
                }
                else {
                    this.getByName();
                }
            }

            this.setState({
                accountFetched: true
            });
        }
    }

	handleSendAccountConfirmationEmail(accountId) {
		this.setState({
			fetching: true,
			msgEmailConfirmation: "Sending Confirmation...",
		});
        (async () => {
			await this.props.accountsDispatch.sendConfirmationEmail(accountId);
        })().then(() => {
			this.setState({
				fetching: false,
				msgEmailConfirmation: "Email Confirmation successfully sent.",
			});
        });
	}

    getByName() {
        (async () => {
            await this.props.accountsDispatch.getByName(this.state.userName);
        })().then(() => {
            const account = this.props.accountsState.account;
            if (account != null &&
                account.studies != null &&
                account.studies.map != null) {
                this.setState({
                    studies: account.studies
                });
            }
        });
    }

    getFormGroups(account) {
        var adminEditing = false;
        var adminRole = false;
        const authenticatedAccount = this.props.accountsState.authenticatedAccount;
        const changePasswordId = "changePasswordInput";
        const create = this.state.create;
        var displayEmailConfirmation = false;
        const editing = this.state.editing;
        const email = elements.getFormGroup("Email", false, elements.getInput("emailInput", !editing, (e) => this.handleValue(createAccountType.email, e.target.value), this.handleKeyDown, elements.inputTypes.text, account.email));
        const emailConfirmationTitle = "Send Account Confirmation Email";
        const firstName = elements.getFormGroup("First Name", true, elements.getInput("firstNameInput", !editing, (e) => this.handleValue(createAccountType.firstName, e.target.value), this.handleKeyDown, elements.inputTypes.text, account.firstName));
        const lastName = elements.getFormGroup("Last Name", true, elements.getInput("lastNameInput", !editing, (e) => this.handleValue(createAccountType.lastName, e.target.value), this.handleKeyDown, elements.inputTypes.text, account.lastName));
        const linkTitle = "Link";
        const optional = " - Optional";
        const password = elements.getFormGroup("Password", false, elements.getInput("passwordInput", !editing, (e) => this.handleValue(createAccountType.password, e.target.value), this.handleKeyDown, elements.inputTypes.password, account.password));
        const passwordConfirm = elements.getFormGroup("Confirm Password", !editing, elements.getInput("passwordConfirmInput", false, this.handlePasswordConfirm, this.handleKeyDown, elements.inputTypes.password, this.state.passwordConfirm));
        const phoneNumber = elements.getFormGroup("Phone Number", true, elements.getInput("phoneNumberInput", !editing, (e) => this.handleValue(createAccountType.phoneNumber, e.target.value), this.handleKeyDown, elements.inputTypes.text, account.phoneNumber));
        const resetPassword = this.state.resetPassword;
        const displayPasswordChange = (
            !create &&
            account.id === authenticatedAccount.id
        );
        const displayPasswordInput = (
            create &&
            !resetPassword
        );
        const role = account.role;
        const roleAdministrator = Accounts.accountRoles.Administrator;
        const roleDropdownId = "roleDropdown";
        const roleDropdownOpen = this.state.roleDropdownOpen;
        const roleGuest = Accounts.accountRoles.Guest;
        const roleLabel = "Role";
        const rolePhysician = Accounts.accountRoles.Physician;
        const roleSiteCoordinator = Accounts.accountRoles.SiteCoordinator;
        const roleStudyManager = Accounts.accountRoles.StudyManager;
        const roleTechnician = Accounts.accountRoles.Technician;
        const roleQa = Accounts.accountRoles.Qa;
        const rolePm = Accounts.accountRoles.Pm;
        const site = this.state.site;
        const siteLabel = "Site";
        var siteName = "";
        if (site != null) {
            siteName = site.name;
        }
        const displaySite = siteName !== "";
        const displaySiteLink = role === roleSiteCoordinator;
        const studies = this.state.studies;
        const studiesLabel = "Studies";
        var studyNames = "";
        if (studies != null) {
            studyNames = utility.getNamesFromArray(studies);
        }
        const displayStudies = studyNames !== "";
        const displayStudiesLink = role === roleStudyManager;
        if (authenticatedAccount != null) {
            adminRole = authenticatedAccount.role === roleAdministrator || rolePm;
            adminEditing = (
                adminRole &&
                editing
            );
            displayEmailConfirmation = (
                adminRole &&
                !account.emailConfirmed &&
                !create
            );
        }
		const userNameAlwaysDisabled = !create;
        const userName = elements.getFormGroup("User Name", false, elements.getInput("userNameInput", userNameAlwaysDisabled, (e) => this.handleValue(createAccountType.userName, e.target.value), this.handleKeyDown, elements.inputTypes.text, account.userName));
		const enabledOrDisabled = elements.getFormGroup("", false, elements.getCheckboxInput('userAccountEnabled', account.enabled, !editing, (e) => this.handleValue(createAccountType.enabled, e.target.checked), null, "Is Account Enabled?") );

        return (
            <div>
                {userName}
                {displayPasswordInput &&
                    <div>
                        {password}
                        {passwordConfirm}
                    </div>
                }
                {displayPasswordChange &&
                    <FormGroup>
                        <Label for={changePasswordId}>Password</Label>
                        <br />
                        <Button className="button" id={changePasswordId} tag={Link} title="Change" to={{ pathname: paths.resetPassword, state: { id: account.id, oldRequired: true } }}>Change</Button>
                    </FormGroup>
                }
                {firstName}
                {lastName}
                {email}
                {displayEmailConfirmation &&
                    <FormGroup>
						{this.state.msgEmailConfirmation && <Alert color="primary"> {this.state.msgEmailConfirmation} </Alert>}
                        <Button className="button" disabled={this.state.fetching} onClick={() => this.handleSendAccountConfirmationEmail(account.id)} title={emailConfirmationTitle}>{emailConfirmationTitle}</Button>
                    </FormGroup>
                }
                {phoneNumber}
                {resetPassword &&
                    <div>
                        <div>
                            <Label for={roleDropdownId}>{roleLabel}</Label>
                            <Dropdown id={roleDropdownId} isOpen={roleDropdownOpen} toggle={() => this.setState({ roleDropdownOpen: !roleDropdownOpen })}>
                                <DropdownToggle caret className="dropdown-hcs" disabled={!adminEditing}>{role}</DropdownToggle>
                                <DropdownMenu>
                                    <DropdownItem key={roleAdministrator} onClick={() => this.handleValue(createAccountType.role, roleAdministrator)}>{roleAdministrator}</DropdownItem>
                                    <DropdownItem key={rolePm} onClick={() => this.handleValue(createAccountType.role, rolePm)}>{rolePm}</DropdownItem>
                                    <DropdownItem key={roleQa} onClick={() => this.handleValue(createAccountType.role, roleQa)}>{roleQa}</DropdownItem>
                                    <DropdownItem key={roleTechnician} onClick={() => this.handleValue(createAccountType.role, roleTechnician)}>{roleTechnician}</DropdownItem>
                                    <DropdownItem key={rolePhysician} onClick={() => this.handleValue(createAccountType.role, rolePhysician)}>{rolePhysician}</DropdownItem>
                                    <DropdownItem key={roleStudyManager} onClick={() => this.handleValue(createAccountType.role, roleStudyManager)}>{roleStudyManager}</DropdownItem>
                                    <DropdownItem key={roleSiteCoordinator} onClick={() => this.handleValue(createAccountType.role, roleSiteCoordinator)}>{roleSiteCoordinator}</DropdownItem>
                                    <DropdownItem key={roleGuest} onClick={() => this.handleValue(createAccountType.role, roleGuest)}>{roleGuest}</DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                        </div>
                        {displaySiteLink &&
                            <div>
                                <FormGroup />
                                <Label for="siteInput">{siteLabel}<i><small>{optional}</small></i></Label>
                                {displaySite ? <Input className="input" disabled id="siteInput" title={siteLabel} value={siteName} /> : <br />}
                                {adminEditing && <Button className="button small-gap" tag={Link} title={linkTitle} to={{ pathname: paths.selectSite, state: { createAccount: create, editAccount: !create, userName: account.userName } }}>{linkTitle}</Button>}
                            </div>
                        }
                        {displayStudiesLink &&
                            <div>
                                <FormGroup />
                                <Label for="studiesInput">{studiesLabel}<i><small>{optional}</small></i></Label>
                                {displayStudies ? <Input className="input" disabled id="studiesInput" title={studiesLabel} value={studyNames} /> : <br />}
                                {adminEditing && <Button className="button small-gap" tag={Link} title={linkTitle} to={{ pathname: paths.linkStudies, state: { createAccount: create, studies: studies, userName: account.userName } }}>{linkTitle}</Button>}
                            </div>
                        }
                    </div>
                }
				{adminRole && enabledOrDisabled}
            </div>
        );
    }

    handleCancel() {
        if (this.state.create) {
            this.props.history.push(paths.home);
        }
        else {
            this.getByName();
            if (this.state.editing) {
                this.setState({
                    editing: false
                });
            }
        }
    }

    handleKeyDown(e) {
        if (e.key === 'Enter') {
            this.handleSave();
        }
    }

    handlePasswordConfirm(e) {
        this.setState({
            error: false,
            passwordConfirm: e.target.value
        });
    }

    handleSave() {
        const account = this.props.accountsState.account;
        const passwordFail = (
            !this.state.resetPassword && (
                account.password === "" ||
                account.password !== this.state.passwordConfirm
            )
        );

        if (account.email === "" ||
            account.userName === "" ||
            passwordFail) {
            this.setState({
                error: true,
                message: "Missing or incorrect fields."
            });
        }
        else {
            this.setState({
                error: false
            });

            const site = this.state.site;
            var siteId = null;
            if (site != null) {
                siteId = site.id;
            }
            const studies = this.state.studies;

            if (this.state.create) {
                this.props.accountsDispatch.create(account, siteId, studies);
                this.props.history.push(paths.homeEmailConfirm);
            }
            else {
                (async () => {
                    await this.props.accountsDispatch.update(siteId, studies);
                })().then(() => {
                    this.props.history.push(paths.manageAccounts);
                });
            }
        }
    }

    handleValue(type, value) {
        const account = this.props.accountsState.account;
        switch (type) {
            case createAccountType.email:
                account.email = value;
                break;
            case createAccountType.firstName:
                account.firstName = value;
                break;
            case createAccountType.lastName:
                account.lastName = value;
                break;
            case createAccountType.password:
                account.password = value;
                break;
            case createAccountType.phoneNumber:
                account.phoneNumber = value;
                break;
            case createAccountType.role:
                account.role = value;
                break;
            case createAccountType.userName:
                account.userName = value;
                break;
            case createAccountType.enabled:
                account.enabled = value;
                break;
            default:
                break;
        }
        this.props.accountsDispatch.set(account);
    }
    
    render() {
        if (!Accounts.authenticatedAllRoles(this.props.accountsState)) {
            return (
                <NotAuthenticated />
            );
        }

        const account = this.props.accountsState.account;
        const cancel = "Cancel";
        var displayEditLink = false;
        const editing = this.state.editing;
        var error = this.state.error;
        var form = null;
        var message = this.state.message;
        const save = "Save";
        var title = "Create Account";

        if (!this.state.create) {
            if (editing) {
                title = "Edit Account";
            }
            else {
                displayEditLink = true;
                title = "Account";
            }
        }

        if (account != null) {
            form = this.getFormGroups(account);
        }
        else {
            error = true;
            message = "Error retrieving account.";
        }

        const alertColor = error ? "danger" : "primary";
        const displayMessage = message !== "";

        return (
            <Form>
                <h1>{title} {displayEditLink && <Button className="button-link" onClick={() => this.setState({ editing: true })}>(Edit)</Button>}</h1>
                {displayMessage && <Alert color={alertColor}>{message}</Alert>}
                {form}
                {editing &&
                    <div className="button-gap">
                        <Button className="button" onClick={this.handleSave} title={save}>{save}</Button>{' '}
                        <Button className="button" onClick={this.handleCancel} title={cancel}>{cancel}</Button>
                    </div>
                }
            </Form>
        );
    }
}

const CreateAccountConnect = withRouter(connect(
    state => ({
        accountsState: state.accounts
    }),
    dispatch => ({
        accountsDispatch: bindActionCreators(Accounts.actionCreators, dispatch)
    })
)(CreateAccountInternal));

export default class CreateAccount extends React.Component {
    render() {
        var create = false;
        var editing = true;
        var linkReturn = false;
        var site = null;
        var studies = null;
        var userName = "";

        const propsState = this.props.location.state;
        if (propsState != null) {
            create = utility.propCheck(propsState.create, create);
            editing = utility.propCheck(propsState.editing, editing);
            linkReturn = utility.propCheck(propsState.linkReturn, linkReturn);
            site = utility.propCheck(propsState.site, site);
            studies = utility.propCheck(propsState.studies, studies);
            userName = utility.propCheck(propsState.userName, userName);
        }

        return (
            <ErrorBoundary>
                <CreateAccountConnect create={create} editing={editing} linkReturn={linkReturn} site={site} studies={studies} userName={userName} />
            </ErrorBoundary>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CreateAccount.js